import * as _ from "lodash";

import { swSettings } from "app/common/services/swSettings";
import { i18nFilter, translate } from "app/filters/i18nFilter";
import { isDurationAfterSplit } from "app/pages/website-analysis/traffic-sources/mmx/components/common/MobileSplit-utils";
import { devicesTypes } from "app/UtilitiesAndConstants/Constants/DevicesTypes";

/** Preserves widgets saved with channel ids from before DRI-10110 channel naming. */
const LEGACY_TRAFFIC_CHANNEL_ID_TO_CURRENT_ID = new Map<string, string>([
    ["Organic Search", "Search - Organic"],
    ["Paid Search", "Search - Paid"],
    ["Search", "Search - Organic"],
    ["Social Organic", "Social - Organic"],
    ["Social Paid", "Social - Paid"],
    ["Social", "Social - Organic"],
]);

interface ITrafficChannelsService {
    getAvailableTrafficChannels: (isUnifiedSearchChannels?: boolean) => any[];
}
class TrafficChannelsService implements ITrafficChannelsService {
    private i18nFilter: ReturnType<typeof i18nFilter>;

    public constructor() {
        this.i18nFilter = i18nFilter();
    }

    public getAvailableTrafficChannels(isUnifiedSearchChannels = false): any[] {
        return [
            {
                text: this.i18nFilter("traffic.channel.dashboard.wizard.direct"),
                name: "Direct",
                id: "Direct",
                innerOrder: 0,
            },
            {
                text: this.i18nFilter("utils.search.organic"),
                name: "Search - Organic",
                id: "Search - Organic",
                innerOrder: 1,
            },
            {
                text: this.i18nFilter("utils.search.paid"),
                name: "Search - Paid",
                id: "Search - Paid",
                innerOrder: 2,
            },
            {
                text: this.i18nFilter("traffic.channel.dashboard.wizard.referrals"),
                name: "Referrals",
                id: "Referrals",
                innerOrder: 3,
            },
            {
                text: this.i18nFilter("traffic.channel.dashboard.wizard.display.ads"),
                name: "Display Ads",
                id: "Display Ads",
                innerOrder: 4,
            },
            {
                text: this.i18nFilter("utils.social.organic"),
                name: "Social - Organic",
                id: "Social - Organic",
                innerOrder: 5,
            },
            {
                text: this.i18nFilter("utils.social.paid"),
                name: "Social - Paid",
                id: "Social - Paid",
                innerOrder: 6,
            },
            {
                text: this.i18nFilter("traffic.channel.dashboard.wizard.mail"),
                name: "Email",
                id: "Email",
                innerOrder: 7,
            },
            {
                text: this.i18nFilter("utils.gen.ai"),
                name: "Gen AI",
                id: "Gen AI",
                innerOrder: 8,
            },
            {
                text: this.i18nFilter("utils.affiliates"),
                name: "Affiliates",
                id: "Affiliates",
                innerOrder: 9,
            },
        ];
    }

    public getChannelById(requestedId: any, isUnifiedSearchChannels = false) {
        if (requestedId == undefined) {
            return undefined;
        }
        const id =
            typeof requestedId === "string"
                ? (LEGACY_TRAFFIC_CHANNEL_ID_TO_CURRENT_ID.get(requestedId) ?? requestedId)
                : requestedId;
        const result = _.filter(this.getAvailableTrafficChannels(isUnifiedSearchChannels), {
            id,
        });
        if (result && result.length > 0) {
            return result[0];
        }
        return undefined;
    }

    public isUnifiedSearchChannelsType(webSource: string, duration: string) {
        if (
            (webSource === devicesTypes.TOTAL || webSource === devicesTypes.MOBILE) &&
            swSettings.isCustomDuration(duration)
        ) {
            const [from, to] = duration.split("-");
            const isMonthly = from.split(".").length === 2;
            const formatedFrom = from.replaceAll(".", "-");
            if (isMonthly && !isDurationAfterSplit(formatedFrom)) {
                return true;
            }
        }
        return false;
    }

    public removeChannelNameInTitle(title: string) {
        const i18nChannelsNames = new Set<string>();
        trafficChannelsService.getAvailableTrafficChannels(false).forEach((channel) => {
            i18nChannelsNames.add(channel.text);
        });
        trafficChannelsService.getAvailableTrafficChannels(true).forEach((channel) => {
            i18nChannelsNames.add(channel.text);
        });
        i18nChannelsNames.forEach((name) => {
            if (title.indexOf(name) > -1) {
                const regexp = new RegExp(name, "g");
                title = title.replace(regexp, "").trim();
            }
        });
        return title;
    }
}

export const trafficChannelsService = new TrafficChannelsService();
